import React from 'react';
import { Box, Popover, PopoverTrigger, PopoverContent, PopoverHeader } from '@chakra-ui/react';
import EditPageBtnGroup from './PopoverEditPageComponents/EditPageBtnGroup';
import EditPageDescription from './PopoverEditPageComponents/EditPageDescription';
import EditPageType from './PopoverEditPageComponents/EditPageType';
import EditPageName from './PopoverEditPageComponents/EditPageName';

const PopoverEditPage = ({ editPage, setEditPage }) => {
	const [editPageProps, setEditPageProps] = React.useState({ ...editPage });

	React.useEffect(() => {
		setEditPageProps({ ...editPage });
	}, [editPage]);

	return (
		<Popover
			isLazy={true}
			autoFocus={true}
			returnFocusOnClose={true}
			isOpen={!!editPage}
			gutter={20}
			placement={'right-start'}
			offset={[-18, 20]}
		>
			<PopoverTrigger>
				<Box></Box>
			</PopoverTrigger>
			<PopoverContent width={'380px'} py={4} px={6}>
				<PopoverHeader p={0} mb={2} fontWeight="bold" border="0">
					<EditPageName {...{ editPageProps, setEditPageProps }} />
				</PopoverHeader>

				<EditPageType {...{ editPageProps, setEditPageProps }} />
				<EditPageDescription {...{ editPageProps, setEditPageProps }} />
				<EditPageBtnGroup {...{ setEditPage, editPageProps }} />
			</PopoverContent>
		</Popover>
	);
};

export default PopoverEditPage;
